module.exports = __webpack_public_path__ + "img/rope_1ThimbleBraid_1eye_4.93cb8ca0.png";